export default __webpack_public_path__ + "static/media/CareHostpital-min.b9f9bf95.png";